(function () {
  var DATE_INPUT_ID = 'CartDrawer-date';
  var FORM_ID = 'CartDrawer-Form';
  var holidays = ['2024-01-01', '2024-01-02', '2024-01-03'];
  var formSubmitBound = false;

  function initCartDrawerWeddingDay() {
    var input = document.getElementById(DATE_INPUT_ID);
    if (!input) return;

    if (!(window.jQuery && window.jQuery.datepicker)) {
      setTimeout(initCartDrawerWeddingDay, 100);
      return;
    }

    var $ = window.jQuery;
    var $input = $('#' + DATE_INPUT_ID);

    $.datepicker.setDefaults({
      closeText: '閉じる',
      prevText: '<先月',
      nextText: '来月>',
      currentText: '今月',
      monthNames: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
      monthNamesShort: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
      dayNames: ['日曜日', '月曜日', '火曜日', '水曜日', '木曜日', '金曜日', '土曜日'],
      dayNamesShort: ['日', '月', '火', '水', '木', '金', '土'],
      dayNamesMin: ['日', '月', '火', '水', '木', '金', '土'],
      weekHeader: '週',
      dateFormat: 'yy-mm-dd',
      firstDay: 0,
      isRTL: false,
      showMonthAfterYear: true,
      yearSuffix: '年'
    });

    if ($input.hasClass('hasDatepicker')) {
      $input.datepicker('destroy');
    }

    $input.datepicker({
      dateFormat: 'yy-mm-dd',
      minDate: 0,
      changeYear: true,
      beforeShowDay: function (day) {
        var yymmdd = $.datepicker.formatDate('yy-mm-dd', day);
        return [holidays.indexOf(yymmdd) === -1, ''];
      }
    });

    $input.off('focus.cartDrawerWeddingDay').on('focus.cartDrawerWeddingDay', function () {
      $(this).datepicker('show');
    });
  }

  function bindFormValidation() {
    if (formSubmitBound) return;
    formSubmitBound = true;

    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form || form.id !== FORM_ID) return;

      var input = document.getElementById(DATE_INPUT_ID);
      if (!input || input.value) return;

      e.preventDefault();
      alert('挙式日（使用日）を選択してください。');
      input.focus();
    });
  }

  function setup() {
    initCartDrawerWeddingDay();
    bindFormValidation();
  }

  window.initCartDrawerWeddingDay = initCartDrawerWeddingDay;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup);
  } else {
    setup();
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
      setTimeout(initCartDrawerWeddingDay, 0);
    });
  }
})();
